import { createReducer, on } from "@ngrx/store";
import { GenericStoreApiData } from "src/components/shared-components/interfaces/generic-store-api-data";
import {
  areaLoadErrorAction,
  areaLoadInitStartAction,
  areaLoadSuccessAction,
  areaUnsetKeyStorage,
} from "../actions/area.actions";

/**
 * Initial state of areas store
 */
const initialState: GenericStoreApiData = {
  loaded: false,
  errorGeneric: false,
  errorNotYetImplemented: false,
  isOldDataInUse: false,
  data: null,
};

/**
 * Reducer for areas
 */
export const AreaReducer = createReducer(
  initialState,
  on(areaUnsetKeyStorage, (areaObject: GenericStoreApiData, action) => {
    return initialState;
  }),
  on(areaLoadInitStartAction, (areaObject: GenericStoreApiData, action) => {
    return { ...areaObject, loaded: false };
  }),
  on(areaLoadSuccessAction, (areaObject: GenericStoreApiData, action) => {
    return {
      loaded: true,
      errorGeneric: false,
      errorNotYetImplemented: false,
      isOldDataInUse: false,
      data: action.areaObject,
    };
  }),
  on(areaLoadErrorAction, (areaObject: GenericStoreApiData, action) => {
    return {
      loaded: true,
      errorGeneric: true,
      errorNotYetImplemented: false,
      isOldDataInUse: false,
      data: null,
    };
  })
);
